module.exports = __webpack_public_path__ + "static/media/redian1.3fda1dc9.png";